module.exports = __webpack_public_path__ + "img/vip-open-tip.6db7253a.png";